import Service, { inject as service } from '@ember/service';

export default Service.extend({
  /**
   * Register services
   */
  errorTracker: service('error-tracker'),

  /**
   * Setup default state here
   */
  propertyDefaults: {
    /**
     * @type {Company|null}   Company we are working on.
     */
    company: null,

    /**
     * @type {Boolean}        True when we have made the call to fetch the user's cards.
     */
    hasLoadedCards: false,

    /**
     * @type {Boolean}        True when we are adding a new card.
     */
    isAddingNewCard: false,

    /**
     * @type {String}         Current stripe token from credit card verification.
     */
    stripeTokenForNewCard: '',

    /**
     * @type {String}         The card id that is being updated, e.g. default, delete, etc.
     */
    updatingCardId: ''
  }
});
